import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'hooks/redux'
import { yup } from 'schemas/validation'
import {
  Header,
  Divider,
  Paragraph,
  Icon,
  Tooltip,
  TextInput,
  TextArea,
} from 'components/patterns'
import strings from 'utils/strings'
import { StyledTemplateDetails } from 'components/pages/PtoTemplates/Template/Template'
import { getIsEditing } from 'selectors/navigator'
import { useDispatch } from 'react-redux'
import { updatePtoTemplate } from 'actions/powerTakeOff'
import { getTemplateById } from 'selectors/powerTakeOff'

export default function Editor({ selectedId }) {
  const dispatch = useDispatch()
  const {
    templateId,
    templateVariant,
    compatibleVariants,
    name,
    templateDescription,
  } = useSelector(getTemplateById, { templateId: selectedId })
  const isEditing = useSelector(getIsEditing)

  const handleUpdateTitle = (value) => {
    dispatch(updatePtoTemplate({ templateId, name: value }))
  }

  const handleUpdateDescription = (value) => {
    dispatch(updatePtoTemplate({ templateId, templateDescription: value }))
  }

  return (
    <>
      <Header>{name}</Header>
      {isEditing && (
        <div style={{ paddingBottom: 18, marginBottom: 5 }}>
          <TextInput
            label={strings.pto_template_name_title}
            data-testid="pto-template-name"
            value={name}
            rules={yup.string().required().max(50)}
            onChange={handleUpdateTitle}
            debounce={false}
          />
        </div>
      )}
      <Divider collapseMargins />
      <Paragraph doMargins>
        <StyledTemplateDetails key="variants">
          <b>{strings.diagnostic_variant}:</b> {templateVariant}{' '}
          {compatibleVariants && compatibleVariants.length > 1 && (
            <Tooltip
              title={strings.pto_template_compatible_app_variants(
                compatibleVariants
              )}
              placement="right"
            >
              <Icon
                icon="question_mark_tooltip"
                fill="outlined"
                color="slatePrimary"
                height={14}
                width={16}
              />
            </Tooltip>
          )}
        </StyledTemplateDetails>
      </Paragraph>
      <Divider collapseMargins />
      <Paragraph doMargins>
        <StyledTemplateDetails key="trans">
          {!isEditing && (
            <>
              <div>
                <b>{strings.pto_template_name_description}</b>
              </div>
              {templateDescription}
            </>
          )}
          {isEditing && (
            <TextArea
              label={strings.pto_template_name_description}
              value={templateDescription}
              rules={yup.string().max(1000)}
              maxLength={1000}
              autosize={{
                minRows: 6,
                maxRows: 8,
              }}
              onChange={handleUpdateDescription}
              debounce={false}
              data-testid="pto-template-desc"
            />
          )}
        </StyledTemplateDetails>
      </Paragraph>
    </>
  )
}

Editor.propTypes = {
  selectedId: PropTypes.string,
}
